function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 14.0782C0 21.0391 5.05556 26.8268 11.6667 28L11.7447 27.9372C11.7187 27.9322 11.6927 27.927 11.6667 27.9218V17.9888H8.16668V14.0782H11.6667V10.9497C11.6667 7.43017 13.9222 5.47486 17.1111 5.47486C18.1222 5.47486 19.2111 5.63129 20.2222 5.78771V9.38548H18.4333C16.7222 9.38548 16.3333 10.2458 16.3333 11.3408V14.0782H20.0667L19.4445 17.9888H16.3333V27.9218C16.3073 27.927 16.2813 27.9322 16.2553 27.9372L16.3333 28C22.9444 26.8268 28 21.0391 28 14.0782C28 6.3352 21.7 0 14 0C6.3 0 0 6.3352 0 14.0782Z",
  fill: "currentColor"
});

var SvgFb = function SvgFb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Fb.d2c15cd1.svg";
export { ForwardRef as ReactComponent };